import { ArrowOutward } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTenants } from '@/services/tenants/useTenants';

export const RECREATE_REPORT_HINT = 'Create it again from Reports';

export const RecreateReportLink = ({ label = RECREATE_REPORT_HINT, testId }: { label?: string; testId: string }) => {
  const { getPath } = useTenants();

  return (
    <Tooltip title={label}>
      <IconButton
        size='small'
        color='secondary'
        component={Link}
        to={getPath('report')}
        aria-label={label}
        data-testid={testId}
      >
        <ArrowOutward fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};
